import { Injectable } from '@angular/core';
import { InsightType } from '../enums';
import { Guid, FitscoveryError } from '@fitscovery/common/types';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from 'apps/partner-web/src/environments/environment';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { UserState, User } from '@fitscovery/user/data-access';

@Injectable()
export class ApiWorkoutUserInsightService {
	@Select(UserState.user) user$: Observable<User>;
	constructor(private httpClient: HttpClient
	) {
	}

	addInsights(workoutId: Guid | string, insightType: InsightType): any {
		let result;
		this.user$.subscribe(async (user: User) => {
			if (user) {
				const urlUserInsight = `${environment.azureFunctionsApi.workouts}/workouts/${workoutId}/user/${user.id}/insights`;
				const requestBody = { workoutId: workoutId, userId: user.id, insightType: insightType };

				result = this.httpClient.post(urlUserInsight, requestBody)
					.pipe(
						catchError((error) => {
							throw new FitscoveryError({ message: error.message, data: error });
						})
					);
			}
		});

		return result;
	}
}
